import React from 'react';
import { useTranslation } from 'react-i18next';

import { DialogMessageContents, ModalDialog } from '@/components/Elements';

/**
 * プロパティ
 */
type Props = {
  // ダイアログ表示/非表示(true=表示)
  isOpen: boolean;
  // OKボタンクリック時の処理
  onClickOKButton: () => void;
};

/**
 * 共有再開完了ダイアログ コンポーネント
 */
export const ShareResumeCompleteDialog = React.memo(
  ({ isOpen, onClickOKButton }: Props) => {
    const { t } = useTranslation();

    return (
      <ModalDialog
        isOpen={isOpen}
        isHiddenCloseButton
        title={t('shareResumeCompleteDialog.共有を再開しました').toString()}
        buttons={[
          { label: 'OK', onClick: onClickOKButton, gtmClassTag: 'dialog-17' },
        ]}
      >
        <DialogMessageContents>
          {t(
            'shareResumeCompleteDialog.再開後は視聴者に通訳結果が共有されます。',
          )}
        </DialogMessageContents>
      </ModalDialog>
    );
  },
);
